"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AltStyledButton = exports.StyledButton = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const setAlignment = (props) => {
    var _a, _b;
    const textAlign = (_a = props.textAlign) !== null && _a !== void 0 ? _a : 'center';
    const verticalAlign = (_b = props.verticalAlign) !== null && _b !== void 0 ? _b : 'middle';
    return (0, styled_components_1.css) `
    text-align: ${textAlign};
    vertical-align: ${verticalAlign};
  `;
};
const setBackground = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const background = (_a = props.background) !== null && _a !== void 0 ? _a : (_d = (_c = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.palettes) === null || _c === void 0 ? void 0 : _c.buyBoxButton) === null || _d === void 0 ? void 0 : _d.background;
    const backgroundHover = (_e = props.backgroundHover) !== null && _e !== void 0 ? _e : (_h = (_g = (_f = props.theme) === null || _f === void 0 ? void 0 : _f.palettes) === null || _g === void 0 ? void 0 : _g.buyBoxButton) === null || _h === void 0 ? void 0 : _h.backgroundHover;
    return (0, styled_components_1.css) `
    background: ${background};
    &:hover {
      background: ${backgroundHover};
    }
  `;
};
const setBorders = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    const border = (_a = props.border) !== null && _a !== void 0 ? _a : (_d = (_c = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.borders) === null || _c === void 0 ? void 0 : _c.buyBoxButton) === null || _d === void 0 ? void 0 : _d.border;
    const borderColor = (_e = props.borderColor) !== null && _e !== void 0 ? _e : (_h = (_g = (_f = props.theme) === null || _f === void 0 ? void 0 : _f.borders) === null || _g === void 0 ? void 0 : _g.buyBoxButton) === null || _h === void 0 ? void 0 : _h.borderColor;
    const borderRadius = (_j = props.borderRadius) !== null && _j !== void 0 ? _j : (_m = (_l = (_k = props.theme) === null || _k === void 0 ? void 0 : _k.borders) === null || _l === void 0 ? void 0 : _l.buyBoxButton) === null || _m === void 0 ? void 0 : _m.borderRadius;
    const borderColorHover = (_o = props.borderColorHover) !== null && _o !== void 0 ? _o : (_r = (_q = (_p = props.theme) === null || _p === void 0 ? void 0 : _p.borders) === null || _q === void 0 ? void 0 : _q.buyBoxButton) === null || _r === void 0 ? void 0 : _r.borderColorHover;
    return (0, styled_components_1.css) `
    border: ${border};
    border-color: ${borderColor};
    border-radius: ${borderRadius};
    &:hover {
      border-color: ${borderColorHover};
    }
  `;
};
const setCursor = () => {
    return (0, styled_components_1.css) `
    &:disabled {
      background: #dddddd;
      border-color: #bababa;
      color: #6e6e6e;
    }
  `;
};
const setDisabled = (props) => {
    var _a;
    const display = (_a = props.display) !== null && _a !== void 0 ? _a : 'block';
    return (0, styled_components_1.css) `
    display: ${display};
  `;
};
const setDisplay = (props) => {
    var _a;
    const display = (_a = props.display) !== null && _a !== void 0 ? _a : 'block';
    return (0, styled_components_1.css) `
    display: ${display};
  `;
};
const setFont = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;
    const color = (_a = props.color) !== null && _a !== void 0 ? _a : (_d = (_c = (_b = props.theme) === null || _b === void 0 ? void 0 : _b.palettes) === null || _c === void 0 ? void 0 : _c.buyBoxButton) === null || _d === void 0 ? void 0 : _d.foreground;
    const fontFamily = (_e = props.fontFamily) !== null && _e !== void 0 ? _e : (_h = (_g = (_f = props.theme) === null || _f === void 0 ? void 0 : _f.typography) === null || _g === void 0 ? void 0 : _g.base) === null || _h === void 0 ? void 0 : _h.fontFamily;
    const fontSize = (_j = props.fontSize) !== null && _j !== void 0 ? _j : (_m = (_l = (_k = props.theme) === null || _k === void 0 ? void 0 : _k.typography) === null || _l === void 0 ? void 0 : _l.base) === null || _m === void 0 ? void 0 : _m.fontSize;
    const fontStyle = (_o = props.fontStyle) !== null && _o !== void 0 ? _o : (_r = (_q = (_p = props.theme) === null || _p === void 0 ? void 0 : _p.typography) === null || _q === void 0 ? void 0 : _q.base) === null || _r === void 0 ? void 0 : _r.fontStyle;
    const fontWeight = (_s = props.fontWeight) !== null && _s !== void 0 ? _s : '400';
    const lineHeight = (_t = props.lineHeight) !== null && _t !== void 0 ? _t : '28px';
    const textDecoration = (_u = props.textDecoration) !== null && _u !== void 0 ? _u : 'none';
    return (0, styled_components_1.css) `
    color: ${color};
    font-family: ${fontFamily};
    font-size: ${fontSize};
    font-style: ${fontStyle};
    font-weight: ${fontWeight};
    line-height: ${lineHeight};
    text-decoration: ${textDecoration};
  `;
};
const setSizing = (props) => {
    var _a, _b, _c;
    const height = (_a = props.height) !== null && _a !== void 0 ? _a : '30px';
    const padding = (_b = props.padding) !== null && _b !== void 0 ? _b : '0';
    const width = (_c = props.width) !== null && _c !== void 0 ? _c : '100%';
    return (0, styled_components_1.css) `
    height: ${height};
    padding: ${padding};
    width: ${width};
  `;
};
exports.StyledButton = styled_components_1.default.button `
  ${setAlignment}
  ${setBackground}
  ${setBorders}
  ${setCursor}
  ${setDisabled}
  ${setDisplay}
  ${setFont}
  ${setSizing}
`;
exports.AltStyledButton = styled_components_1.default.button `
  font-size: 10px;
`;
